import { Check } from "lucide-react";
import { Section, SectionHeading } from "@/components/common/Section";
import { useReveal } from "@/hooks/useReveal";
import { aboutImage } from "@/data/content";

const points = [
  "In-house design, fabrication & installation",
  "Enterprise-grade, durable materials",
  "Trusted by 350+ corporate clients",
  "Serving Bengaluru & Karnataka since day one",
];

export function About() {
  const imgRef = useReveal();
  return (
    <Section id="about" bg="white">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
        <div ref={imgRef} className="reveal relative">
          <img
            src={aboutImage}
            alt="BNZ Solutions premium reception branding project in a Bengaluru corporate office"
            loading="lazy"
            className="w-full aspect-[4/5] object-cover"
          />
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-navy text-white px-8 py-6 max-w-[220px]">
            <div className="font-heading text-3xl font-bold text-gold">10+</div>
            <div className="text-sm text-white/70 mt-1">years crafting premium workspaces</div>
          </div>
        </div>

        <div>
          <SectionHeading
            eyebrow="About BNZ Solutions"
            title="A premium branding & signage partner for modern businesses"
            subtitle="We help companies transform ordinary workspaces into powerful brand experiences. From reception walls to complete office branding, signage systems and commercial printing — every project is delivered with precision, premium materials and enterprise-grade finish."
          />
          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-charcoal">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center bg-gold/15 text-gold-dark">
                  <Check className="h-4 w-4" />
                </span>
                <span className="text-sm md:text-base leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
